import React from 'react';
import styled from '@emotion/styled';
import { ITheme, Shimmer, ShimmerPlaceholder } from '../../../../../../ui';
import {
	StyledParkingProductCard,
	StyledParkingProductCardContent,
	StyledParkingProductCardFooter,
	StyledParkingProductCardHeader,
	StyledParkingProductCardSubtitle,
	StyledParkingProductCardTitle,
} from './StyledParkingProductCard';
import { Price, PriceWrap, Savings } from './ParkingProductPrice';
import Responsive from '../../../../../../ui/utils/Responsive';
import themed from '../../../../../../ui/themer/themed';

export const StyledParkingProductCardShimmer = styled(StyledParkingProductCard)`
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		&:nth-of-type(3) {
			display: none;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		&:nth-of-type(2) {
			display: none;
		}
	}
`;

const ImageShimmer = styled(Shimmer)<{}, ITheme>`
	background: ${themed(({ shimmer }) => shimmer.placeholder.background)};
	padding-bottom: 55.5555%;
`;

const HrShimmer = styled(Shimmer)<{}, ITheme>`
	background: ${themed(({ shimmer }) => shimmer.placeholder.background)};
`.withComponent('hr');

const TextPlaceholder = styled(ShimmerPlaceholder)<{ width: string }, ITheme>`
	height: 1em;
	width: ${({ width }) => width};
`;

const TitleShimmer = styled(Shimmer)`
	padding-top: 7px;
`.withComponent(StyledParkingProductCardTitle);

const SubtitleShimmer = styled(Shimmer)`
	padding-top: 8px;
	padding-bottom: 7px;
`.withComponent(StyledParkingProductCardSubtitle);

const ListShimmer = styled(Shimmer)<{}, ITheme>`
	color: ${themed(({ shimmer }) => shimmer.placeholder.background)};

	li {
		margin-top: 0.3em;
		margin-bottom: 0.3em;
		padding-top: 0.2em;
		padding-bottom: 0.2em;
	}

	${TextPlaceholder} + ${TextPlaceholder} {
		margin-top: 0.6em;
	}
`.withComponent('ul');

const FooterShimmer = Shimmer.withComponent(StyledParkingProductCardFooter);

export const ParkingProductCardShimmer = () => (
	<StyledParkingProductCardShimmer data-testid="parking-product-card-shimmer">
		<StyledParkingProductCardHeader>
			<ImageShimmer />
		</StyledParkingProductCardHeader>

		<StyledParkingProductCardContent>
			<TitleShimmer>
				<TextPlaceholder width="80%" />
			</TitleShimmer>
			<SubtitleShimmer>
				<TextPlaceholder width="70%" />
			</SubtitleShimmer>

			<HrShimmer />

			<ListShimmer>
				<li>
					<TextPlaceholder width="95%" />
					<TextPlaceholder width="20%" />
				</li>
				<li>
					<TextPlaceholder width="98%" />
					<TextPlaceholder width="30%" />
				</li>
			</ListShimmer>
		</StyledParkingProductCardContent>

		<FooterShimmer>
			<div>
				<PriceWrap>
					<Price>
						<TextPlaceholder width="150px" />
					</Price>
				</PriceWrap>
				<Savings>
					<TextPlaceholder width="120px" />
				</Savings>
			</div>
			<div>
				<TextPlaceholder width="95px" />
			</div>
		</FooterShimmer>
	</StyledParkingProductCardShimmer>
);
